export const Invoice_URL = `/api/Invoice`


export function GetAllInvoices(axiosPrivate :any) {
    return axiosPrivate.get(`${Invoice_URL}`);
}

export function GetInvoiceById(axiosPrivate :any,id: number) {
  
    return axiosPrivate.get(`${Invoice_URL}/${id}`);
}

export function DeleteInvoice(axiosPrivate :any,id: number) {
    return axiosPrivate.delete(`${Invoice_URL}/${id}`);
}

export function GenerateInvoice(axiosPrivate :any,id: number) {
    return axiosPrivate.get(`${Invoice_URL}/GetGenerate/${id}`);
}

